import { FC, useEffect, useMemo, useState } from 'react';
import { generatePath } from 'react-router-dom';

import TransparentSpinner from 'components/spinners/TransparentSpinner';
import ErrorTryAgain from 'components/ErrorTryAgain';
// import useFilteredAssignments from './useFilteredAssignments';
import styled from 'styled-components';
import { useCaseGetCases } from 'api/case/case';
import { BasicCaseModel, CaseStatusEnum, CaseTypeEnum } from 'api/model';
import Routes from 'constants/Routes';
import CasesList from 'components/CasesList';
import DatePicker, { CustomInput } from 'components/inputs/DatePicker';
import Checkbox from 'components/inputs/Checkbox';

const Horizontal = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  gap: 10px;
`;

const UnclosedCasesPage: FC = () => {
  const getCasesCall = useCaseGetCases();

  // default to 1 month ago
  const [selectedDate, setSelectedDate] = useState<Date>(
    new Date(new Date().setMonth(new Date().getMonth() - 1))
  );

  const [
    hideCasesWithAllAssignmentsRemoved,
    setHideCasesWithAllAssignmentsRemoved,
  ] = useState<boolean>(false);

  // Utfyllnadsuppdrag (CarPlaceholder-uppdrag) ligger alltid på ärenden av typen
  // Placeholder. De ska inte visas i listan över öppna ärenden.
  const visibleCases = useMemo(
    () =>
      getCasesCall.data?.filter(
        (c) => c.caseTypeID !== CaseTypeEnum.Placeholder
      ),
    [getCasesCall.data]
  );

  const handleCaseClick = (model: BasicCaseModel) => {
    window.open(
      generatePath(Routes.case.case, { id: String(model.caseID) }),
      generatePath(Routes.case.case, { id: String(model.caseID) })
    );
  };

  const getCases = async () => {
    try {
      await getCasesCall.mutateAsync({
        data: {
          to: selectedDate,
          caseTypes: [],
          caseStatuses: [CaseStatusEnum.Open, CaseStatusEnum.Pending],
          hideCasesWithAllAssignmentsRemoved,
          includeInvoicedCases: false,
        },
      });
    } catch (error) {
      // do nothing
    }
  };

  useEffect(() => {
    getCases();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate.getTime(), hideCasesWithAllAssignmentsRemoved]);

  const renderList = () => {
    if (getCasesCall.status === 'error') {
      return <ErrorTryAgain onTryAgain={() => getCases()} />;
    }

    if (!visibleCases) {
      return <TransparentSpinner />;
    }

    return (
      <>
        <Horizontal>
          <span>Skapade före:</span>
          <div>
            <DatePicker
              calendarStartDay={1}
              customInput={<CustomInput date={selectedDate} />}
              dateFormat="yyyy-MM-dd"
              locale="sv"
              onChange={(d) => {
                if (d) {
                  setSelectedDate(d);
                }
              }}
              populateHolidays
              selected={selectedDate}
            />
          </div>
          {visibleCases.length > 0 && (
            <span>({visibleCases.length} ärenden)</span>
          )}
          <Checkbox
            checked={hideCasesWithAllAssignmentsRemoved}
            onChange={(e) => {
              setHideCasesWithAllAssignmentsRemoved(e.currentTarget.checked);
            }}
          >
            <span>Dölj ärenden med endast borttagna uppdrag</span>
          </Checkbox>
        </Horizontal>
        <CasesList
          cases={visibleCases}
          loading={getCasesCall.isLoading}
          onCaseClick={handleCaseClick}
        />
      </>
    );
  };

  return (
    <>
      {/* <FilterBar assignments={filteredAssignments ?? []} showAdvancedFilters /> */}
      {renderList()}
    </>
  );
};

export default UnclosedCasesPage;
